import { IoHome, IoGrid, IoPerson } from 'react-icons/io5'
import postCategories from './postCategories'

const headerNavLinks = [
	{
		href: '/',
		title: 'Homepage',
		icon: IoHome,
	},
	{
		href: '/category',
		title: 'Categories',
		icon: IoGrid,
		children: postCategories.map((cat) => ({
			href: `/category/${cat.slug}`,
			title: cat.title,
		})),
	},
	{
		href: '/about-me',
		title: 'About me',
		icon: IoPerson,
	},
]

export default headerNavLinks
